import React from "react";
import { TextField, IconButton } from "@material-ui/core";

interface Props {
  label: string;
  type?: string;
  value: any;
  onChange?: any;
  helperText?: any;
  error?: boolean;
  hasButton?: boolean;
  buttonIcon?: any;
  onButtonClick?: any;
  required?: boolean;
  name?: string;
  isReadOnly?: boolean;
  multiline?: boolean;
  rows?: number;
  autoComplete?: string;
}

const CommonTextField = ({
  label,
  type = "",
  value,
  onChange,
  helperText = "",
  error = false,
  hasButton = false,
  buttonIcon = null,
  onButtonClick,
  required = false,
  name = "",
  isReadOnly = false,
  multiline = false,
  rows,
  autoComplete = "off",
}: Props) => {
  const FieldButton = () => {
    return (
      <IconButton onClick={onButtonClick} color="primary" size="small" edge="end">
        {buttonIcon || "..."}
      </IconButton>
    );
  };

  const textFieldInputProps = { endAdornment: <FieldButton /> };

  return (
    <TextField
      disabled={isReadOnly}
      id={name}
      name={name}
      label={label}
      multiline={multiline || Boolean(rows)}
      rows={rows}
      required={required}
      type={type}
      value={value}
      onChange={onChange}
      helperText={helperText}
      error={error}
      variant="outlined"
      size="small"
      InputLabelProps={{
        shrink: true,
      }}
      InputProps={hasButton ? textFieldInputProps : {}}
      inputProps={{ autoComplete }}
      fullWidth
    />
  );
};

export default CommonTextField;
